import { Card, Col, Row, Steps } from 'antd'
import { useRouter } from 'next/router'
import { createContext, useCallback, useState } from 'react'
import { SignLayout } from 'src/components/Layout/SignLayout'
import ReciveInformationForm from 'src/components/RegisterForms/ReciveInformationForm'
import { SEO } from 'src/components/SEO'
import BASE_CONFIG from 'src/configs/base'

const { Step } = Steps
export const FromContext = createContext()

const stepData = [
	// {
	// 	title: 'Thông tin tài khoản',
	// 	description: 'Bao gồm các thông tin về tài khoản và mật khẩu.',
	// 	step: 1,
	// 	isFillForm: false,
	// },
	{
		title: 'Thông tin doanh nghiệp',
		description: 'Bao gồm các thông tin cơ bản về doanh nghiệp',
		step: 1,
		isFillForm: false,
	},
	{
		title: 'Thông tin xuất hóa đơn',
		description: 'Bao gồm các thông tin hóa đơn doanh nghiệp',
		step: 2,
		isFillForm: false,
	},
	{
		title: 'Thông tin cá nhân',
		description: 'Các thông tin cá nhân người liên hệ',
		step: 3,
		isFillForm: false,
	},
]

const Register = () => {
	const [step, setStep] = useState(0)
	const [isDone, setIsDone] = useState(false)
	const [isChange, setIsChange] = useState(false)
	const [dataFormForRegister, setDataFormForRegister] = useState({})
	const [useInforFromPreviousStep, setUseInforFromPreviousStep] = useState(false)
	const changeStep = useCallback((s) => {
		if (s <= 3) {
			setStep(s)
		} else {
			setIsDone(true)
		}
	}, [])

	// const StepForms = useMemo(() => {
	// 	// if (isDone) return <WelcomeCard />
	// 	// if (step === 0) return <EnterpriseForm onNextStep={changeStep} />
	// 	// if (step === 1) return <BillForm onNextStep={changeStep} />
	// 	// if (step === 2) return <ProfileForm onNextStep={changeStep} />
	// 	return <ReciveInformationForm />
	// }, [step, changeStep, isDone])

	const handleChangeStep = (e) => {
		setStep(e)
	}

	return (
		<FromContext.Provider
			value={{
				dataFormForRegister,
				setDataFormForRegister: setDataFormForRegister,
				stepData,
				setIsDone,
				isChange,
				useInforFromPreviousStep,
				setUseInforFromPreviousStep,
			}}
		>
			<div className="register__page">
				<SEO
					data={{
						title: `Đăng ký | ${BASE_CONFIG.SLOGAN}`,
						description: 'Đăng ký trở thành đối tác',
						keywords: 'Đăng ký, tạo tài khoản, đăng nhập',
						url: BASE_CONFIG.PAGE_URL + useRouter().asPath,
					}}
				/>
				<div className="register__page-container">
					<Row gutter={16}>
						<Col
							xl={{ span: 19, order: 1 }}
							lg={{ span: 24, order: 2 }}
							md={{ span: 24, order: 2 }}
							sm={{ span: 24, order: 2 }}
							xs={{ span: 24, order: 2 }}
						>
							<div className="register__page-forms">
								<div className="forms-img">
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img src="/images/register-form-img.png" alt="Đăng ký" />
								</div>
								<div className="forms-forms">
									{
										isDone && (
											<div className="forms--header">
												<span className="forms--header__welcome">
													Chào mừng,{' '}
													<span style={{ color: '#cc0000' }}>
														{dataFormForRegister.InvoiceBuyerName}
													</span>
												</span>
												<p className="forms--header__message">
													Hệ thống <span style={{ color: '#cc0000' }}>247Express</span> đã cập nhật
													thông tin thành công. Nhân viên sẽ liên hệ đến bạn trong thời gian sớm
													nhất.
												</p>
											</div>
										)
										// : (
										// 	<div className="forms-header">
										// 		<h1>Đăng ký</h1>
										// 		<span>Bạn đã có tài khoản?</span>
										// 		<Link href="/dang-nhap">Đăng nhập</Link>
										// 	</div>
										// )
									}
									<ReciveInformationForm />
								</div>
							</div>
						</Col>
						<Col
							xl={{ span: 5, order: 2 }}
							lg={{ span: 24, order: 1 }}
							md={{ span: 24, order: 1 }}
							sm={{ span: 24, order: 1 }}
							xs={{ span: 24, order: 1 }}
						>
							{/* <div className="register__page-step">
								<Steps direction="vertical" current={step} onChange={handleChangeStep}>
									{stepData.map((item, index) => (
										<Step
											disabled={step < index}
											key={item.title}
											title={item.title}
											description={item.description}
										/>
									))}
								</Steps>
							</div> */}
							{/* <div className="register__page-step mobile">
								<Steps
									responsive={false}
									direction="horizontal"
									current={step}
									onChange={(e) => setStep(e)}
								>
									{stepData.map((item) => (
										<Step key={item.title} description={item.description} />
									))}
								</Steps>
								<div className="step-content">
									<h4>{stepData[step].title}</h4>
									<p>{stepData[step].description}</p>
								</div>
							</div> */}
						</Col>
					</Row>
				</div>
			</div>
		</FromContext.Provider>
	)
}

Register.Layout = SignLayout
export default Register
